import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Text from "components/common/Text";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import TextField from "components/common/TextField";
import DatePicker from "components/common/DatePicker";
import IconButton from "components/common/IconButton";
import JarvisButton from "components/JarvisButton";
import CheckIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SectionTitle from "components/SectionTitle";
import { Checkbox, CircularProgress, FormHelperText } from "@mui/material";
import OtpInput from "react-otp-input";
import Button from "components/common/Button";
import { makeStyles } from "@mui/styles";
import { masterApis } from "stores/master/masterApis";
import { useDispatch, useSelector } from "react-redux";
import { commonActions } from "stores/common/commonActions";
import { customerApis } from "stores/customer/customerApis";

const useStyles = makeStyles(() => ({
  otpContainer: {
    height: "56px",
    width: "100%",
  },
  otpInput: {
    height: "56px",
    width: "57px",
    border: "1px solid #E0E7FF",
    flex: "1",
  },
  otpResend: {
    color: "#72aaff",
    background: "transparent !important",
    padding: "0",
    boxShadow: "none !important",
    fontSize: "12px",
    display: "inline",
    textTransform: "none",
    cursor: "pointer",
    minWidth: "auto",
    marginRight: "8px",
  },
}));

const CKYCauto = (props) => {
  const classes = useStyles();
  const {
    formData,
    formError,
    isVerified,
    isLoading,
    hasFirstAttempError,

    handleChange,
    handleVerification,
    toggleKYCtype,
    isReKyc,
    reKycButton,
    fromTokenLink,
    isToShowDigioSignInButton,
    handleProceedDocumentSigningClick,
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const getStoreUserName = useSelector(
    (state) => state.customer.loginProfile.name,
  );

  const toShowAdharInput = useSelector(
    (state) => state.common.featureConfig.enableAadharVerification,
  );

  const [isSize, setSize] = useState(window.innerHeight > 800);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  const [isOtpSend, setIsOtpSend] = useState(false);
  const [resendTime, setResendTime] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [isAadharDone, setisAadharDone] = useState(true);
  const [aadharNumber, setAadharNumber] = useState("");
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [optVerifyButton, setVerifyButton] = useState(false);
  const [fullName, setFullName] = useState(getStoreUserName);
  const [fullNameDisable, setFullnameDisable] = useState(false);
  const [aadharverficationFailed, setAadharverficationFailed] = useState(false);

  const [formErrorAadhar, setFormErrorAadhar] = useState({
    aadharNumber: "",
  });
  const [isVerifiedAadhar, setIsVerifiedAadhar] = useState(false);
  const [nameFormError, setNameFormError] = useState({ name: "" });

  const getPanFormattedValue = (value = "") => {
    const normalizedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    let formattedValue = "";

    for (const ch of normalizedValue) {
      if (formattedValue.length < 5) {
        if (/[A-Z]/.test(ch)) {
          formattedValue += ch;
        }
      } else if (formattedValue.length < 9) {
        if (/[0-9]/.test(ch)) {
          formattedValue += ch;
        }
      } else if (formattedValue.length === 9) {
        if (/[A-Z]/.test(ch)) {
          formattedValue += ch;
        }
      } else {
        break;
      }
    }

    return formattedValue;
  };

  const updateSize = () => {
    setSize(window.innerHeight > 800);
  };

  useEffect(() => {
    setFullName(getStoreUserName);
  }, [getStoreUserName]);

  useEffect(() => {
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  });

  const handleCheckBoxChange = (value) => {
    setCheckBoxStatus(value);
  };

  const handleSendOtp = async (isResendOtp) => {
    setIsLoadingButton(true);
    setIsButtonVisible(false);
    const dataObject = {
      aadhaarNumber: aadharNumber,
    };
    try {
      const getAadharOtp = masterApis.getOtpAadharKYCApi;
      Promise.resolve(getAadharOtp(dataObject)).then((res) => {
        if (res.code == "SOS174") {
          if (isResendOtp) {
          } else {
            setIsOtpSend(true);
          }
        } else {
          setFormErrorAadhar({ ...formErrorAadhar, aadharNumber: res.message });
          setAadharverficationFailed(true);
          setIsLoadingButton(false);
          setIsButtonVisible(true);
        }
      });
    } catch (error) {
      console.log(error);
      setIsLoadingButton(false);
      setIsButtonVisible(true);
    }
  };

  const handleRequestOtp = () => {
    startTimer();
    handleSendOtp(true);
  };

  const startTimer = (initialTime = 30, intervalDuration = 1000) => {
    if (resendTime > 0) {
      return;
    }
    setResendTime(initialTime);
    const id = setInterval(() => {
      setResendTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(id);
          return 0;
        }
        return prevTime - 1;
      });
    }, intervalDuration);
    setIntervalId(id);
  };

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  const handleAadharChange = (e) => {
    const value = e.target.value;
    setAadharNumber(value);

    const errorMessage = validateAadharNumber(value);
    setFormErrorAadhar({ ...formErrorAadhar, aadharNumber: errorMessage });
  };

  const validateAadharNumber = (value) => {
    const regex = /^\d{12}$/;
    if (!value) {
      return "Aadhaar number is required";
    } else if (!regex.test(value)) {
      return "Aadhaar number must be 12 digits";
    } else {
      return "";
    }
  };

  const verfiyOtpHandler = async () => {
    setVerifyButton(true);
    const objectData = {
      otp: formData.otp,
      aadhaarNumber: aadharNumber,
      consent: "Y",
    };
    try {
      const otpVerifyAPiCall = masterApis.verfyOtpAadharKYCApi;
      Promise.resolve(otpVerifyAPiCall(objectData)).then((res) => {
        if (res.code == "SRC001") {
          dispatch(commonActions.setToast({ message: res.message }));
          setIsVerifiedAadhar(true);
          setisAadharDone(false);
          handleChange({
            name: "otp",
            value: "",
          });
          setVerifyButton(false);
        } else {
          dispatch(commonActions.setToast({ message: res.message }));
          setVerifyButton(false);
        }
      });
    } catch (error) {
      console.log(error);
      setVerifyButton(false);
    }
  };

  const validateName = (name) => {
    if (!name.trim()) {
      return "Full Name is required";
    }
    if (!/^[a-zA-Z\s]+$/.test(name)) {
      return "Name can only contain letters and spaces";
    }
    if (name.length < 3) {
      return "Name must be at least 3 characters";
    }
    return "";
  };

  const handleNameVerification = async () => {
    const nameError = validateName(fullName);

    if (nameError) {
      setNameFormError({ name: nameError });
      return;
    }
    try {
      await customerApis.updateProfileDetails({
        fullName: fullName,
      });
      dispatch(commonActions.setToast({ message: "successfully updated" }));
      setFullnameDisable(true);
    } catch (err) {
      console.log(err);
      setFullnameDisable(false);
    }
  };

  return (
    <Stack sx={{ pt: { xs: 2, md: 0 }, alignItems: "flex-start" }}>
      {/* Back button */}
      <SectionTitle
        sx={{ display: { xs: "flex", md: "none" } }}
        heading={isReKyc ? "Re-CKYC Update" : "Complete CKYC"}
        startIcon={
          <IconButton
            onClick={() => history.push({ pathname: "/customer/dashboard" })}
          >
            <ArrowBackIcon sx={{ fontSize: 20, color: "#222B3E" }} />
          </IconButton>
        }
      />
      {!fromTokenLink && isReKyc && (
        <Text
          mb={3}
          sx={{
            display: { xs: "none", md: "flex" },
            fontSize: { xs: "body2.fontSize", md: "body1.fontSize" },
            fontWeight: 400,
          }}
        >
          Re-CKYC Update
        </Text>
      )}

      <Text
        mb={2}
        sx={{
          fontSize: { xs: "body2.fontSize", md: "body1.fontSize" },
          fontWeight: 400,
          width: { xs: "360px", md: 850 },
          textAlign: "left",
        }}
      >
        Please keep your Aadhaar and PAN number handy and make sure that the
        mobile number linked to your Aadhaar number is within the network range,
        as you will get OTP to verify CKYC
      </Text>

      {hasFirstAttempError ? (
        <Stack direction="row" alignItems="center" mb={2}>
          <ErrorIcon sx={{ fontSize: 24, color: "#BC2B2B" }} />
          <Text
            variant="body2"
            sx={{ color: "#BC2B2B", maxWidth: "400px", ml: 0.5 }}
          >
            Verification Failed! We can't find your CKYC records.
          </Text>
        </Stack>
      ) : null}

      {/* aadhaar and sent otp */}

      {toShowAdharInput && (
        <Stack
          sx={{
            display: "block",
            width: "100%",
            mb: 3,
          }}
        >
          <TextField
            type="text"
            label="Aadhaar No."
            value={aadharNumber}
            onChange={handleAadharChange}
            error={Boolean(formErrorAadhar.aadharNumber)}
            disabled={isVerifiedAadhar}
            inputProps={{ maxLength: 12 }}
            sx={{ maxWidth: 400 }}
          />
          <FormHelperText
            sx={{
              color: isVerifiedAadhar
                ? "success.main"
                : formErrorAadhar.aadharNumber
                  ? "error.main"
                  : "text.secondary",
            }}
          >
            {isVerifiedAadhar
              ? "Successfully Completed."
              : formErrorAadhar.aadharNumber || " "}
          </FormHelperText>
          {isOtpSend ? null : aadharNumber.length == 12 ? (
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ maxWidth: 400 }}
            >
              <Text variant="caption1"></Text>
              <Text
                variant="caption1"
                sx={{
                  whiteSpace: "nowrap",
                  alignSelf: "flex-end",
                }}
              >
                {isLoadingButton && <CircularProgress size={20} />}
                {isButtonVisible && (
                  <Button
                    component="span"
                    className={classes.otpResend}
                    onClick={() => handleSendOtp(false)}
                    disabled={resendTime > 0 ? true : false}
                    loading={isLoading}
                  >
                    Send OTP
                  </Button>
                )}
              </Text>
            </Stack>
          ) : null}
        </Stack>
      )}

      {/* resend otp */}
      {!isVerifiedAadhar && isOtpSend && (
        <Stack
          sx={{
            display: "block",
            width: { xs: "100%", md: "26.3%" },
            mb: 3,
          }}
        >
          <OtpInput
            className={classes.otpContainer}
            inputStyle={classes.otpInput}
            value={formData.otp}
            numInputs={6}
            onChange={(otp) =>
              handleChange({
                name: "otp",
                value: otp,
              })
            }
            isInputNum={true}
            separator={<span>&nbsp;</span>}
          />
          <Stack direction="row" justifyContent="space-between">
            <Text variant="caption1"></Text>
            <Text
              variant="caption1"
              sx={{
                whiteSpace: "nowrap",
                alignSelf: "flex-end",
              }}
            >
              <Button
                component="span"
                className={classes.otpResend}
                onClick={handleRequestOtp}
                disabled={resendTime > 0 ? true : false}
                loading={isLoading}
              >
                Resend
              </Button>

              {resendTime > 0 ? `in 00:${resendTime}` : null}
            </Text>
          </Stack>
          <JarvisButton
            disableEndIcon={true}
            sx={{ width: { xs: "100%", md: "auto" } }}
            onClick={verfiyOtpHandler}
            loading={optVerifyButton}
          >
            Confirm OTP
          </JarvisButton>
        </Stack>
      )}

      <TextField
        type="text"
        label="Full Name (as on Pan Card)"
        value={fullName}
        onChange={(e) => {
          setFullName(e.target.value);
          if (nameFormError.name) {
            setNameFormError({ name: validateName(e.target.value) });
          }
        }}
        helperText={nameFormError.name}
        error={!!nameFormError.name}
        sx={{ maxWidth: 400, mb: 2 }}
        disabled={toShowAdharInput ? isVerified || isAadharDone : false}
        InputLabelProps={{
          shrink: !!fullName, // shrink label if fullName is truthy
        }}
      />

      <JarvisButton
        sx={{ width: { xs: "91%", md: "auto" }, mb: 2 }}
        disableEndIcon={true}
        loading={isLoading}
        onClick={handleNameVerification}
        disabled={toShowAdharInput ? isVerified || isAadharDone : false}
      >
        Save
      </JarvisButton>

      {/* PAN */}
      <TextField
        type="text"
        label="PAN No."
        value={formData.panNumber}
        onChange={(e) => {
          const typedChar = e.nativeEvent?.data || "";
          const formattedPan = getPanFormattedValue(e.target.value);

          // Some Android IMEs can emit only the latest typed character and
          // replace the whole value in controlled inputs. Preserve previous PAN.
          const nextPanValue =
            !formattedPan && typedChar && formData.panNumber
              ? getPanFormattedValue(`${formData.panNumber}${typedChar}`)
              : formattedPan;

          handleChange({
            name: "panNumber",
            value: nextPanValue,
          });
        }}
        helperText={formError.panNumber}
        error={formError.panNumber}
        disabled={toShowAdharInput ? isVerified || isAadharDone : false}
        sx={{ maxWidth: 400, mb: 2 }}
        inputProps={{
          maxLength: 10,
          autoCapitalize: "characters",
          autoCorrect: "off",
          spellCheck: false,
          inputMode: "text",
        }}
      />

      {/* Data*/}
      <DatePicker
        label="Date of Birth"
        value={formData.dateOfBirth}
        onChange={(value) => handleChange({ name: "dateOfBirth", value })}
        helperText={formError.dateOfBirth}
        error={formError.dateOfBirth}
        disabled={toShowAdharInput ? isVerified || isAadharDone : false}
        textFieldProps={{
          sx: { maxWidth: 400, mb: 2 },
        }}
      />

      {/* Msg: success */}
      {isVerified ? (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ display: "flex", mb: { xs: 0, md: 4 } }}
        >
          <CheckIcon sx={{ fontSize: 24, color: "#18A70E" }} />
          <Text variant="body2" sx={{ color: "#18A70E" }}>
            Account verification successful
          </Text>
        </Stack>
      ) : null}

      {!fromTokenLink && isReKyc ? (
        <Stack
          justifyContent={{ xs: "center", md: "flex-start" }}
          mt={4}
          sx={{
            width: { xs: "100%", md: "auto" },
            position: { xs: "fixed", md: "relative" },
            bottom: { xs: 10 },
          }}
        >
          <JarvisButton
            disableEndIcon={true}
            sx={{ width: { xs: "91%", md: "auto" } }}
            disabled={isAadharDone}
            onClick={() => handleVerification()}
            loading={reKycButton}
          >
            Submit for re-verification
          </JarvisButton>
        </Stack>
      ) : !isVerified ? (
        <Stack
          direction="row"
          justifyContent={{ xs: "center", md: "flex-start" }}
          mb={{ xs: 7, md: 3 }}
          mt={6}
          alignItems="center"
          sx={{ width: { xs: "100%", md: "auto" }, background: "#fff" }}
        >
          {isSize ? (
            <Stack
              sx={{
                position: { xs: "fixed", md: "unset" },
                bottom: { xs: "10px", md: "unset" },
                width: { xs: "90vw", md: "unset" },
              }}
            >
              {/* CKYC Checkbox */}
              <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                marginBottom="1rem"
              >
                <Checkbox
                  sx={{ px: 1, py: 0, pl: 0 }}
                  onChange={(e) => handleCheckBoxChange(e.target.checked)}
                  value={checkBoxStatus}
                />
                <Box>
                  <Text
                    variant="caption1"
                    sx={{
                      display: {
                        md: "block",
                      },
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: "3",
                      overflow: "hidden",
                    }}
                  >
                    I hereby provide consent to Ventugrow Consultants Pvt Ltd to
                    retrieve my KYC from <b>CKYCRR </b>
                    and download it as per{" "}
                    <b>
                      SEBI (IA) Regulations, (2013)/ SEBI (RA) Regulations,
                      (2014){" "}
                    </b>
                    including all subsequent amendments.
                  </Text>
                </Box>
              </Stack>
              <JarvisButton
                sx={{ width: { xs: "100%", md: "auto" } }}
                loading={isLoading}
                disabled={!checkBoxStatus}
                onClick={handleVerification}
              >
                Submit for verification
              </JarvisButton>
            </Stack>
          ) : (
            <Stack
              sx={{
                position: { xs: "static", md: "unset" },
                bottom: { xs: "10px", md: "unset" },
                width: { xs: "90vw", md: "unset" },
              }}
            >
              {aadharverficationFailed && (
                <Text variant="body2" sx={{ color: "#a7110e" }}>
                  Aadhaar verification failed. You can continue with manual KYC.
                  <Text
                    component="span"
                    sx={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontSize: "16px",
                      color: "blue",
                      "&:hover": {
                        color: "#e60b0b",
                      },
                    }}
                    onClick={() => toggleKYCtype(true)}
                  >
                    {" "}
                    Switch to manual KYC
                  </Text>
                </Text>
              )}

              {/* CKYC Checkbox */}
              <Stack
                sx={{
                  alignItems: { xs: "flex-start", md: "center" },
                  marginBottom: { xs: "1rem", md: "0.313rem" },
                }}
                direction="row"
                justifyContent="flex-start"
              >
                <Checkbox
                  sx={{ px: 1, py: 0, pl: 0 }}
                  onChange={(e) => handleCheckBoxChange(e.target.checked)}
                  value={checkBoxStatus}
                />
                <Box>
                  <Text
                    variant="caption1"
                    sx={{
                      display: {
                        md: "block",
                      },
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: "3",
                      overflow: "hidden",
                    }}
                  >
                    I hereby provide consent to Ventugrow Consultants Pvt Ltd to
                    retrieve my KYC from <b>CKYCRR </b>
                    and download it as per{" "}
                    <b>SEBI (IA) Regulations, (2013), </b>
                    including all subsequent amendments.
                  </Text>
                </Box>
              </Stack>
              <JarvisButton
                sx={{ width: { xs: "100%", md: "30%" } }}
                loading={isLoading}
                disabled={!checkBoxStatus}
                onClick={handleVerification}
              >
                Submit for verification
              </JarvisButton>
            </Stack>
          )}
        </Stack>
      ) : null}

      {fromTokenLink && isToShowDigioSignInButton && (
        <Stack
          sx={{
            position: { xs: "fixed", md: "unset" },
            bottom: {
              xs: "calc(10px + var(--safe-area-inset-bottom)) !important",
              md: "unset",
            },
            width: { xs: "90vw", md: "unset" },
          }}
        >
          <JarvisButton
            // loading={isLoading}
            onClick={() => handleProceedDocumentSigningClick()}
            sx={{ width: { xs: "100%", md: "auto" } }}
          >
            Proceed to Client Agreement
          </JarvisButton>
        </Stack>
      )}
    </Stack>
  );
};

export default CKYCauto;
